import LogRocket from 'logrocket';

import { ENV_NAMES, EnvName, getEnv } from 'jf/utils/getEnv';

const env: EnvName = getEnv();
if (env === ENV_NAMES.PRODUCTION) {
  LogRocket.init('rb8k2e/jellyfish', {
    dom: {
      textSanitizer: true,
      inputSanitizer: true,
    },
  });
  const user = window.dx.user;
  if (user) {
    const props = {
      email: user.email || '',
      name: user.name || '',
      isOnboarded: user.isOnboarded,
      isAdmin: user.isCustomerAdmin,
      jobLevel: user.jobLevel || '',
    };
    Object.keys(user.company).forEach((k) => {
      props[`company-${k}`] = user.company[k];
    });
    LogRocket.identify(user.id.toString(), {
      ...props,
    });
  }
}
